import { render } from "./OrgaoAetImg.vue?vue&type=template&id=b7ff9796&scoped=true"
import script from "./OrgaoAetImg.vue?vue&type=script&lang=ts"
export * from "./OrgaoAetImg.vue?vue&type=script&lang=ts"

import "./OrgaoAetImg.vue?vue&type=style&index=0&id=b7ff9796&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b7ff9796"

export default script